var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "room-item", class: { over: _vm.room.state == 1 } },
    [
      _c("div", { staticClass: "roll-header" }, [
        _c("div", { staticClass: "room-name" }, [
          _c(
            "div",
            {
              staticClass: "btn-tit",
              class: { official: _vm.room.isOfficial },
            },
            [_vm._v(" " + _vm._s(_vm.room.isOfficial ? "官方" : "主播") + " ")]
          ),
          _vm._v(" " + _vm._s(_vm.room.name) + " "),
        ]),
        _c("div", { staticClass: "join-count" }, [
          _c("i", { staticClass: "ivu-icon ivu-icon-md-people" }),
          _vm._v("：" + _vm._s(_vm.room.userCount) + " "),
        ]),
      ]),
      _c("div", { staticClass: "room-body" }, [
        _c(
          "div",
          {
            staticClass: "avatar-box",
            class: { official: _vm.room.isOfficial },
          },
          [
            _vm.room.avatar
              ? _c("img", { attrs: { src: _vm.$imgfilter(_vm.room.avatar) } })
              : _c("img", { attrs: { src: require("@/assets/svg/logo.svg") } }),
            _c("c-svg", {
              staticClass: "itembg",
              attrs: { src: "itembg.svg", fill: "rgb(0, 0, 0,.2)" },
            }),
          ],
          1
        ),
        _c(
          "ul",
          { staticClass: "room-awards" },
          _vm._l(_vm.room.items, function (item, award_index) {
            return _c("li", { key: award_index }, [
              _c(
                "div",
                { staticClass: "award", class: "rarity_" + item.rarity },
                [
                  _c("img", {
                    attrs: {
                      src: item.itemPic
                        ? _vm.$imgfilter(item.itemPic)
                        : require("@/assets/images/icon/cash.png"),
                    },
                  }),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "price" },
          [
            _vm._v(" 总价值: "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("conversion")(_vm.room.totalPrice))),
            ]),
            _c("c-svg", {
              attrs: {
                src: "bill.svg",
                width: "12",
                height: "12",
                fill: "#4762f2",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "time" }, [
          _vm._v(" Ends: "),
          _c("i", [
            _vm._v(_vm._s(_vm.room.expir_time.replace(/\s{1}[^]+/, ""))),
          ]),
        ]),
        _c("div", { staticClass: "resolve-btn" }, [
          _c("span", { staticClass: "resolve-btn-icon-wrap" }, [
            _vm.room.password
              ? _c("i", { staticClass: "ivu-icon ivu-icon-md-lock" })
              : _vm._e(),
            _c("i", { staticClass: "ivu-icon ivu-icon-md-play" }),
          ]),
          _vm._v(
            " " + _vm._s(_vm.room.state == 1 ? "已结束" : "加入房间") + " "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }